import ActionTypes from './actionTypes'

const ActionCategories = [
  {
    id: ActionTypes.WAIT,
    name: 'wait'
  },
  {
    id: ActionTypes.CONDITION,
    name: 'condition'
  },
  {
    id: ActionTypes.EMAIL,
    name: 'email'
  },
  {
    id: ActionTypes.INTEGRATION,
    name: 'integration'
  },
  {
    id: ActionTypes.NOTIFICATION,
    name: 'notification'
  },
  {
    id: ActionTypes.WEBHOOK,
    name: 'webhook'
  },
  {
    id: ActionTypes.END_AUTOMATION,
    name: 'end-automation'
  },
  {
    id: ActionTypes.GOTO,
    name: 'goto'
  }
]

export default ActionCategories



// WEBPACK FOOTER //
// ./src/utils/dictionaries/actionCategories.js